export const SET_MESSAGES = 'set-messages';

export default function setMessages({ messages }) {
  return {
    type: SET_MESSAGES,
    messages,
  };
}
